// @flow

import { connect } from 'react-redux';

import * as Zap from 'app/entities/Zap';
import App from 'app/zap-mover/components/App';
import { fromAccountIdParam, toAccountIdParam } from 'app/zap-mover/Selectors';

const mapStateToProps = state => {
  return {
    fromAccountId: fromAccountIdParam(state),
    isMoving: Zap.selectors.all.isMoving(state),
    toAccountId: toAccountIdParam(state),
  };
};

export default connect(mapStateToProps)(App);
